//import $ from 'imports/jquery'
import browser from 'imports/browser-detect'
import stickCommon from 'site/stick.common'
import AOS from 'imports/aos'
let stickSite = {
    browser:browser(),
    init: function () {
        //add browser name
        if (stickSite.browser && stickSite.browser.name) {
            $('body').addClass("browser_" + stickSite.browser.name)
        }

        //mobile stuff
        $('.ui-link').removeClass('ui-link')

        //disable img drag
        $('img').on('dragstart', function (event) {
            event.preventDefault()
        })
        if (stickSite.browser && stickSite.browser.mobile) {
            $('body').addClass("device-mobile")
        } else {
            $('body').addClass("device-notmobile")
        }

        //analytics
        stickCommon.scAddAnalyticsEventHandle('body')

        //aos
        AOS.init({
            offset: 0,
            duration: 500,
            once: true
        })

        //final
        window.dispatchEvent(new Event('resize'))
    },
    siteResize: function () {
        const docWidth = $(window).width()
        const docHeight = $(window).height()
        const docRat = docWidth / docHeight

        $('.bg-img').hide()
        $('body').removeClass('bg-mobile')
        $('body').removeClass('bg-desktop')
        if (docWidth < 800) {
            $('body').addClass('bg-mobile')
            $('#bg-mobile').show()
        } else {
            $('body').addClass('bg-desktop')
            $('#bg-desktop').show()
        }

        const bgh = $('#bg').height()
        $('.inner-zone').height(bgh)
    }
}
export default stickSite
